export default __webpack_public_path__ + "static/media/invite.987bbbde.svg";